var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('a',{attrs:{"href":_vm.restechUrl,"target":"_blank"}},[_vm._v("restech.it")])])}
var staticRenderFns = []

export { render, staticRenderFns }